import { useTranslation } from '../../../utils/useTranslation';
import { WithHint } from '../../feedback/Tooltip';
import { IconInfoBold } from '../../icon/IconInfoBold';
import { Typography } from '../../typography/Typography';
import { ProductUnavailableLabelProps } from './types';

export const ProductUnavailableLabel = ({ widthHint, ...other }: ProductUnavailableLabelProps) => {
    const t = useTranslation();
    const content = (
        <Typography variant="body2" color="error" weight="medium" {...other}>
            {t('Недоступен')}
        </Typography>
    );

    return widthHint ? (
        <WithHint
            message={t(
                'Не удалось получить данные о товаре. Проверьте наличие и отображение товара на сайте или напишите в поддержку',
            )}
            trigger={<IconInfoBold color="var(--color-danger)" cursor="pointer" size={12} />}
        >
            {content}
        </WithHint>
    ) : (
        content
    );
};
